export default __webpack_public_path__ + "static/media/pdf-document-gray.6143bd8b.svg";